<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage"><a href="#/nav#ntitle-page"><img alt="title page" id="title-page" src="9780062429735_tpimage.jpg" style="margin:0.00em; text-align:center; height:100%"/></a></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?6ba0b0cd